import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container from './Container';
import Icon from './Icon';
import { propStyles } from '../styleHelper';

const StyledLink = styled.a`
  display: flex;
  align-items: center;
  flex: 1;
  cursor: pointer;
  width: 100%;
  height: 50px;
  padding: 0;
  transition: all 0.3s ease;
  font-size: 16px;
  text-decoration: none;
  line-height: 1.2;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  color: ${props =>
    props.disabled ? props.text.theme.disabled : props.theme.text.normal};
  &:hover {
    color: ${props =>
      props.disabled ? props.text.theme.disabled : props.theme.text.text700};
  }
  ${propStyles};
`;

const MenuItem = ({
  disabled,
  className,
  children,
  text,
  icon,
  onClick: handleOnClick,
  ...props
}) => {
  const onClick = event => {
    if (disabled) {
      event.preventDefault();
      return false;
    }
    if (handleOnClick) {
      return handleOnClick(event);
    }
    return true;
  };

  const iconRender =
    typeof icon === 'string' ? (
      <Icon
        className={icon}
        iconSize="medium"
        marginRight="10px"
        flex="0 0 15px"
      />
    ) : (
      icon
    );

  return (
    <StyledLink
      {...props}
      disabled={disabled}
      onClick={onClick}
      className={[className, disabled ? 'disabled' : false]
        .filter(Boolean)
        .join(' ')}
    >
      {children || (
        <>
          {iconRender || <Container width="15px" flex="0 0 15px" />}
          {text}
        </>
      )}
    </StyledLink>
  );
};

MenuItem.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
};

MenuItem.defaultProps = {
  className: null,
  disabled: false,
  children: null,
  text: null,
  icon: null,
  onClick: null,
};

export default MenuItem;
